import React, { Component, Fragment } from 'react';
import { Checkbox } from 'semantic-ui-react'
import ComparisonCollapsibleCard from '../components/comparison_collapsible_card'

class ComparisonSelection extends Component {
  constructor(props){
    super(props)

    this.state = {
      tree: this.props.tree,
      risk_ids: this.props.riskIds,
      translations: this.props.translations
    }
    this.cancelWorkPhaseToggle = false
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.translations !== this.props.translations ){
      this.setState({
        translations: nextProps.translations
      })
    }
    this.setState({
      tree: nextProps.tree,
      risk_ids: nextProps.riskIds
    })
  }

  subtractArrays = (minuend, subtrahend) => {
    return minuend.filter(function(i) {return subtrahend.indexOf(i) < 0;});
  }

  onSelectChange = (e, options, value) => {
    e.stopPropagation() //Stops the parent's onClick event
    var tree = this.state.tree
    var riskIds = this.state.risk_ids

    if (options.level==='workphase'){
      tree[options.workPhaseIndex].selected = value
      var activities = tree[options.workPhaseIndex].activities
      activities.map((activity, i)=>{
        activity.selected = value
        var hazards = activity.hazards
        hazards.map((hazard, j)=>{
          hazard.selected = value
          var unwanted_events = hazard.unwanted_events
          unwanted_events.map((unwanted_event, k)=>{
            unwanted_event.selected = value
            return true
          })
          return true
        })
        return true
      })

      var ids = tree[options.workPhaseIndex].ids
      if (value){
        riskIds = riskIds.concat(ids)
      } else {
        riskIds = this.subtractArrays(riskIds, ids)
      }

    }
    else if (options.level==='activity') {
      tree[options.workPhaseIndex].selected = null
      var activity = tree[options.workPhaseIndex].activities[options.activityIndex]
      activity.selected = value
      var hazards = activity.hazards
      hazards.map((hazard, j)=>{
        hazard.selected = value
        var unwanted_events = hazard.unwanted_events
        unwanted_events.map((unwanted_event, k)=>{
          unwanted_event.selected = value
        })
      })

      if (value){
        riskIds = riskIds.concat(activity.ids)
      } else {
        riskIds = this.subtractArrays(riskIds, activity.ids)
      }
    }
    else if (options.level==='hazard') {
      tree[options.workPhaseIndex].selected = null
      tree[options.workPhaseIndex].activities[options.activityIndex].selected = null
      var hazard = tree[options.workPhaseIndex].activities[options.activityIndex].hazards[options.hazardIndex]
      hazard.selected = value
      var unwanted_events = hazard.unwanted_events
      unwanted_events.map((unwanted_event, k)=>{
        unwanted_event.selected = value
      })

      if (value){
        riskIds = riskIds.concat(hazard.ids)
      } else {
        riskIds = this.subtractArrays(riskIds, hazard.ids)
      }
    }
    else if (options.level==='unwanted_event') {
      tree[options.workPhaseIndex].selected = null
      tree[options.workPhaseIndex].activities[options.activityIndex].selected = null
      tree[options.workPhaseIndex].activities[options.activityIndex].hazards[options.hazardIndex].selected = null
      var unwanted_event = tree[options.workPhaseIndex].activities[options.activityIndex].hazards[options.hazardIndex].unwanted_events[options.unwantedEventIndex]

      unwanted_event.selected = value
      if (value){
        riskIds = riskIds.concat(unwanted_event.ids)
      } else {
        riskIds = this.subtractArrays(riskIds, unwanted_event.ids)
      }
    }

    riskIds = [...new Set(riskIds)];
    this.props.setRiskIds(riskIds)

    this.setState({
      tree: tree
    })
  }

  onCardClick = (e, options) => {
    var tree = this.state.tree

    if (options.level==='workphase'){
      tree[options.workPhaseIndex].expanded = !options.expanded
      this.props.setComparisonCollapseAll(!options.expanded)
    }
    else if (options.level==='activity') {
      tree[options.workPhaseIndex].activities[options.activityIndex].expanded = !options.expanded
    }
    else if (options.level==='hazard') {
      tree[options.workPhaseIndex].activities[options.activityIndex].hazards[options.hazardIndex].expanded = !options.expanded
    }
    else if (options.level==='unwanted_event') {
      tree[options.workPhaseIndex].activities[options.activityIndex].hazards[options.hazardIndex].unwanted_events[options.unwantedEventIndex].selected = !options.expanded
    }

    this.setState({
      tree: tree
    })

  }

  renderWorkPhases = (tree) => {
    const { select_all, select_none, work_phase_or_ambient_exposure } = this.state.translations
    var workPhaseElements = []

    tree.map((workphase, index)=>{

      var cardOptions = {
        level: 'workphase',
        workPhaseIndex: index,
        expanded: workphase.expanded
      }

      var workPhaseContent = (
        <Fragment>
          <div className="comparison-workphase-name">
            { workphase.work_phase_or_ambient_exposure }
          </div>
          <div className="cards-activity-indicator">
            <div style={{float: "left", marginRight: "10px"}}>
              <div>
                <Checkbox
                  style={{margin: 0}}
                  radio
                  key={'true' + index}
                  label={select_all}
                  name={'work_phase' + index}
                  onChange={ (e) => this.onSelectChange(e, cardOptions, true) }
                  checked={ workphase.selected }
                />
              </div>
              <div>
                <Checkbox
                  style={{margin: 0}}
                  radio
                  key={'false' + index}
                  label={select_none}
                  name={ "work_phase" +  index}
                  onChange={ (e) => this.onSelectChange(e, cardOptions, false) }
                  checked={ workphase.selected !== null ? !workphase.selected : false }
                />
              </div>
            </div>
          </div>
        </Fragment>
      )

      var renderOptions = {
        activities: workphase.activities,
        workPhaseIndex: index
      }

      workPhaseElements = workPhaseElements.concat(
        <ComparisonCollapsibleCard
          onCardClick={ (e) => this.onCardClick(e, cardOptions) }
          expand={ workphase.expanded }
          key={ workphase.work_phase_or_ambient_exposure }
          headerLabel={ work_phase_or_ambient_exposure }
          headerText={ workphase.work_phase_or_ambient_exposure }
          headerContent={ workPhaseContent }
          content={ this.renderActivities(renderOptions) }
          className={ "work-phase" }
        />
      )

    })
    return workPhaseElements
  }

  renderActivities = (options) => {
    const { select, unselect } = this.state.translations
    const activity_label = this.state.translations.activity
    var activityElements = []

    options.activities.map((activity, index)=>{
      var cardOptions = {
        level: 'activity',
        workPhaseIndex: options.workPhaseIndex,
        activityIndex: index,
        expanded: activity.expanded
      }
      var activityContent = (
        <Fragment>
          <div className="comparison-activity-name">
            { activity.activity }
          </div>
          <div className="cards-activity-indicator">
            <div style={{float: "left", marginRight: "10px"}}>
              <div>
                <Checkbox
                  style={{margin: 0}}
                  radio
                  key={'true' + index}
                  label={select}
                  name={'activity' + index}
                  onChange={ (e) => this.onSelectChange(e, cardOptions, true) }
                  checked={ activity.selected }
                />
              </div>
              <div>
                <Checkbox
                  style={{margin: 0}}
                  radio
                  key={'false' + index}
                  label={unselect}
                  name={ "activity" +  index}
                  onChange={ (e) => this.onSelectChange(e, cardOptions, false) }
                  checked={ activity.selected !== null ? !activity.selected : false}
                />
              </div>
            </div>
          </div>
        </Fragment>
      )

      var renderOptions = {
        hazards: activity.hazards,
        workPhaseIndex: options.workPhaseIndex,
        activityIndex: index
      }
      activityElements = activityElements.concat(
        <ComparisonCollapsibleCard
          onCardClick={ (e) => this.onCardClick(e, cardOptions) }
          expand={ activity.expanded }
          key={ activity.activity }
          headerLabel={ activity_label }
          headerText={ activity.activity }
          headerContent={ activityContent }
          content={ this.renderHazards(renderOptions) }
          className={ "activity" }
        />
      )
    })
  return activityElements
  }

  renderHazards = (options) => {
    const { select, unselect } = this.state.translations
    const hazard_label = this.state.translations.hazard
    var hazardElements = []

    options.hazards.map((hazard, index)=>{
      var cardOptions = {
        level: 'hazard',
        workPhaseIndex: options.workPhaseIndex,
        activityIndex: options.activityIndex,
        hazardIndex: index,
        expanded: hazard.expanded
      }
      var hazardContent = (
        <Fragment>
          <div className="comparison-hazard-name">
            { hazard.hazard }
          </div>
          <div className="cards-activity-indicator">
            <div style={{float: "left", marginRight: "10px"}}>
              <div>
                <Checkbox
                  style={{margin: 0}}
                  radio
                  key={'true' + index}
                  label={select}
                  name={'hazard' + index}
                  onChange={ (e) => this.onSelectChange(e, cardOptions, true) }
                  checked={ hazard.selected }
                />
              </div>
              <div>
                <Checkbox
                  style={{margin: 0}}
                  radio
                  key={'false' + index}
                  label={unselect}
                  name={ "hazard" +  index}
                  onChange={ (e) => this.onSelectChange(e, cardOptions, false) }
                  checked={ hazard.selected !== null ? !hazard.selected : false}
                />
              </div>
            </div>
          </div>
        </Fragment>
      )

      var renderOptions = {
        unwanted_events: hazard.unwanted_events,
        workPhaseIndex: options.workPhaseIndex,
        activityIndex: options.activityIndex,
        hazardIndex: index
      }
      hazardElements = hazardElements.concat(
        <ComparisonCollapsibleCard
          onCardClick={ (e) => this.onCardClick(e, cardOptions) }
          expand={ hazard.expanded }
          key={ hazard.hazard }
          headerLabel={ hazard_label }
          headerText={ hazard.hazard }
          headerContent={ hazardContent }
          content={ this.renderUnwantedEvents(renderOptions) }
          className={ "hazard" }
        />
      )
    })
  return hazardElements
  }

  renderUnwantedEvents = (options) => {
    const { select, unselect } = this.state.translations
    const unwanted_event_label = this.state.translations.unwanted_event
    var unwantedEventElements = []
    options.unwanted_events.map((unwanted_event, index)=>{

      var cardOptions = {
        level: 'unwanted_event',
        workPhaseIndex: options.workPhaseIndex,
        activityIndex: options.activityIndex,
        hazardIndex: options.hazardIndex,
        unwantedEventIndex: index
      }

      var unwantedEventContent = (
        <Fragment>
          <div className="comparison-unwanted-event-name">
            { unwanted_event.unwanted_event }
          </div>
          <div className="cards-activity-indicator">
            <div style={{float: "left", marginRight: "10px"}}>
              <div>
                <Checkbox
                  style={{margin: 0}}
                  radio
                  key={'true' + index}
                  label={select}
                  name={'unwanted_event' + index}
                  onChange={ (e) => this.onSelectChange(e, cardOptions, true) }
                  checked={ unwanted_event.selected }
                />
              </div>
              <div>
                <Checkbox
                  style={{margin: 0}}
                  radio
                  key={'false' + index}
                  label={unselect}
                  name={ "unwanted_event" +  index}
                  onChange={ (e) => this.onSelectChange(e, cardOptions, false) }
                  checked={ unwanted_event.selected !== null ? !unwanted_event.selected : false}
                />
              </div>
            </div>
          </div>
        </Fragment>
      )

      unwantedEventElements = unwantedEventElements.concat(
        <ComparisonCollapsibleCard
          expand={ unwanted_event.expanded }
          key={ unwanted_event.unwanted_event }
          headerLabel={ unwanted_event_label }
          headerText={ unwanted_event.unwanted_event }
          headerContent={ unwantedEventContent }
          className={ "unwanted-event" }
        />
      )
    })
  return unwantedEventElements
  }

  render() {
    const { tree } = this.state
    return (
      <div className="cards-div">
        <div className="cards-area">
          { tree &&
            this.renderWorkPhases(tree)
          }
        </div>
      </div>
    )
  }
}

export default ComparisonSelection



// WEBPACK FOOTER //
// ./src/components/comparison_selection.js